import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { UtilService, DialogService, TranslationService, NotificationService, DatagridService } from '../../../shared/index'; //app/shared/index barrel;
import { NameValue } from '../../../shared/model/name-value.model';
import { AffCodeMassAddComponent } from '../../../affcode/affcode-mass-add/affcode-mass-add.component';
import { PaymentSourceService } from '../../../revenue/shared/payment-source/payment-source.service';
import { PaymentSource } from '../../../revenue/shared/payment-source/payment-source.model';
import { PaymentType } from '../../../revenue/shared/payment-types/payment-type.model';
import { TranslateService } from '@ngx-translate/core';
import { InvoicePayment } from '../../../revenue/shared/invoice-payment/invoice-payment.model';
import { NavigationService } from '../../../shared/navigation/navigation.service';
import { MassCommParameterService } from '../../../communication/shared/mass-comm-parameter.service';
import { MassCommParamNav } from '../../../communication/shared/mass-comm-param-nav.model';
import { RegistrationMin } from '../../shared/registration/registration-min.model';
import { RegistrationSearchParams } from '../../shared/registration/registration-search-params.model';
import { RegistrationSearchResult } from '../../shared/registration/registration-search-result.model';
import { EventV4RegistrationService } from '../../shared/registration/event-v4-registration.service';

@Component({
  selector: 'wl-event-v4-registration-management-selector',
  templateUrl: './event-v4-registration-management-selector.component.html',
  styleUrl: './event-v4-registration-management-selector.component.less',
    standalone: false
})
export class EventV4RegistrationManagementSelectorComponent implements OnInit {
  public error: string = '';
  public _invoicePayment: InvoicePayment;
  public searchParams: RegistrationSearchParams;
  public registrationSearchResult: RegistrationSearchResult;
  public isSearching: boolean;
  public showModal = false;
  @ViewChild('massAddAffCode', { static: false }) massAddAffCode: AffCodeMassAddComponent;
  @Output() public confirmed: EventEmitter<number> = new EventEmitter<number>();
  public registrations: Array<RegistrationMin>;
  public selectAll: boolean;
  public selectedAction: number;
  public executingAction: boolean;
  public paymentSources: Array<PaymentSource>;
  public applyDate: Date;
  public paymentDate: Date;
  public selectedPaymentSource: string;
  public paymentType: PaymentType;
  public eventId: number;
  public _noneText: string;
  public _executing: boolean = false;
  public constructor(
    private _paymentSourceService: PaymentSourceService,
    private _translationService: TranslationService,
    private _utilService: UtilService,
    private _registrationService: EventV4RegistrationService,
    private _notificationService: NotificationService,
    private _navigationService: NavigationService,
    private _massCommParameterService: MassCommParameterService
  ) {
    this.registrations = new Array<RegistrationMin>();
    this.selectAll = false;
    this.selectedAction = 0;
    this.paymentSources = new Array<PaymentSource>();
    this._invoicePayment = new InvoicePayment();
    this.applyDate = new Date();
    this.paymentDate = new Date();
    this.selectedPaymentSource = '';
    this.paymentType = new PaymentType();
    this._noneText = '';
    this.eventId = 0;
    this.registrationSearchResult = new RegistrationSearchResult();
    this.searchParams = new RegistrationSearchParams();
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 99999;
    this.isSearching = false;
  }
  public ngOnInit() {
    this.loadPaymentSources();
  }
  public getInvoices = (): void => {};
  public loadPaymentSources() {
    this._paymentSourceService.getPaymentSources().then((data: Array<PaymentSource>) => {
      this.paymentSources = data;
      this.paymentSourceAddNone(this.paymentSources);
    });
  }
  paymentSourceAddNone(data: Array<PaymentSource>): Promise<Array<PaymentSource>> {
    let noneItem: PaymentSource = new PaymentSource();
    noneItem.Descr = '';
    return this._translationService.get('common.none').then((result: string) => {
      this._noneText = this._utilService.toTitleCase(result);
      noneItem.PaymentSource = this._noneText;
      this.paymentSources.splice(0, 0, noneItem);
      return Promise.resolve(this.paymentSources);
    });
  }
  public showDialog(action: number) {
    this.selectedAction = action;
    this.showModal = true;
  }
  public toggleSelectAll() {
    if (this.selectAll == true) {
      for (let reg of this.registrations) {
        reg.Selected = true;
      }
    } else {
      for (let reg of this.registrations) {
        reg.Selected = false;
      }
    }
  }
  public onPaymentSourceChange = (data: string): void => {
    this.selectedPaymentSource = data;
  };
  public onPaymentTypeChange = (data: any): void => {
    this._utilService.map(data, this.paymentType);
  };
  public cancel = (): void => {
    this.showModal = false;
  };
  public execute = (): void => {
    let regHeaderIds = new Array<number>();
    for (let reg of this.registrations) {
      if (reg.Selected == true) {
        regHeaderIds.push(reg.Id);
      }
    }
    switch (this.selectedAction) {
      case 2:
        let selectedRegistrationIds = this.registrations.filter((x) => x.Selected).map((x) => x.Id);
        // nothing to do
        if (!selectedRegistrationIds.length) return;
        this._executing = true;
        this._registrationService.sendConfirmationEmail(selectedRegistrationIds).then(
          () => {
            this.showModal = false;
            this._executing = false;
            this._translationService
              .getTitlecase('events.registration.management.selector.send-confirmation-email-success')
              .then((successMessage) => this._notificationService.success(successMessage));
            this.confirmed.emit(this.selectedAction);
          },
          (error) => {
            this.error = this._utilService.extractErrorMessage(error);
            this._executing = false;
          }
        );
        break;
      case 5:
        //mass add aff code
        let profileIds = new Array<number>();
        for (let reg of this.registrations) {
          if (reg.Selected == true) {
            profileIds.push(reg.ProfileID);
          }
        }
        this.massAddAffCode.setProfileIds(profileIds);
        this.massAddAffCode.addAffCodes();
        this.showModal = false;
        this.confirmed.emit(this.selectedAction);
        break;
      case 6:
        //email selected registrations
        this._executing = true;
        let emailProfileIds = new Array<number>();
        let emailManuals = new Array<NameValue>();
        for (let reg of this.registrations) {
          if (reg.Selected == true) {
            if (reg.ProfileID > 0) {
              emailProfileIds.push(reg.ProfileID);
            } else {
              if (this._utilService.isNotNullEmptyOrWhitespace(reg.Email)) {
                let nv = new NameValue(reg.DisplayName, reg.Email);
                emailManuals.push(nv);
              }
            }
          }
        }
        this._massCommParameterService.setEventId(this.eventId);
        this._massCommParameterService.setFromType('registrations');
        this._massCommParameterService.setEmailParams(emailManuals);
        this._massCommParameterService.setProfileIdParams(emailProfileIds);
        let navFrom = new MassCommParamNav();
        navFrom.DisplayText = this._translationService.getInstantCapitalizeFirstCharacter('events.labels.back-to-event');
        navFrom.NavigatedFromRoute = '/event/' + this.eventId.toString() + '/registrations';
        this._massCommParameterService.setNavigatedFromParams(navFrom);
        this._navigationService.navigateToCommunicationNewEmailMessage();
        this._executing = false;
        break;
      case 7:
        //apply payments
        if (this._executing) return;
        let invoicePayments: Array<InvoicePayment> = [];
        for (let reg of this.registrations) {
          if (reg.Selected == true) {
            let ip = new InvoicePayment();
            ip.Amount = reg.AmountInvoiced - reg.AmountPaid;
            ip.ApplyDate = this.applyDate;
            ip.DateChanged = new Date();
            ip.DateCreated = new Date();
            ip.InvoiceNumber = reg.InvoiceNum;
            ip.PaymentDate = this.paymentDate;
            ip.PaymentSource = this.selectedPaymentSource;
            ip.PaymentType = this.paymentType.PaymentType;
            ip.PaymentTypeID = this.paymentType.PaymentTypeId;
            ip.ProfileID = reg.ProfileID;
            invoicePayments.push(ip);
          }
        }
        // do nothing if empty
        if (invoicePayments.length) {
          this.error = '';
          this._executing = true;
          this._registrationService.applyManualPayments(invoicePayments).then(
            // success
            () => {
              this._executing = false;
              this.showModal = false;
              this.confirmed.emit(this.selectedAction);
            },
            // error
            (error) => {
              this._executing = false;
              this.error = this._utilService.extractErrorMessage(error);
            }
          );
        }
        break;
      case 9:
        this._executing = true;
        this._registrationService.exportRegistrationsExtendedAndFiltered(this.eventId, regHeaderIds).then(
          (data: string) => {
            this._navigationService.popupSafeNavigate(data);
            this._executing = false;
          },
          () => {
            this._executing = false;
          }
        );
        break;
      default:
        break;
    }
  };
  public searchRegistrations() {
    this.isSearching = true;
    //no paging always have full data results
    this.searchParams.PageNumber = 1;
    this.searchParams.PageSize = 99999;
    this._registrationService.searchRegistrations(this.searchParams).then(
      (data: RegistrationSearchResult) => {
        this.isSearching = false;
        this.registrationSearchResult = data;
        this.registrations = data.Result;
      },
      () => {
        this.isSearching = false;
      }
    );
  }
}
